export default __webpack_public_path__ + "static/media/icon3.353fa09f.svg";